import request from '@/api/request'

// 获取租户列表
export const getAvailableCompanyList = (params) => {
  return request({
    url: 'base/adm/company/getAvailableCompanyList',
    method: 'post',
    params
  })
}

// riskgo列表
export const getRiskGoList = (params) => {
  return request({
    url: 'admin/order/adm/riskgoRecord/getListPage',
    method: 'get',
    params
  })
}

// 提交
export const updateRiskgoRecord = (data) => {
  return request({
    url: 'admin/order/adm/riskgoRecord/updateRiskgoRecord',
    method: 'post',
    data
  })
}

// 分页查询处理列表
export const getListPageProcess = (params) => {
  return request({
    url: 'admin/order/adm/riskgoProcessRecord/getListPage',
    method: 'get',
    params
  })
}

// 导出
export const exportRisk = (params) => {
  return request({
    url: 'order/adm/riskgoRecord/export',
    method: 'get',
    params
  })
}